import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
    LayoutDashboard,
    Users,
    UserCog,
    FileSpreadsheet,
    LogOut,
    Lock,
    CalendarClock,
    Wallet,
    BarChart3,
    FileWarning,
} from "lucide-react";

const NAV = [
    { to: "/panel", label: "Kontrol Paneli", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/tahsilat", label: "Tahsilat Ekranı", icon: Wallet, testid: "nav-tahsilat" },
    { to: "/musteriler", label: "Müşteriler", icon: Users, testid: "nav-customers" },
    { to: "/takvim", label: "Vade Takvimi", icon: CalendarClock, testid: "nav-calendar" },
    { to: "/raporlar", label: "Raporlar", icon: BarChart3, testid: "nav-reports" },
    { to: "/ice-aktar", label: "SOA İçe Aktar", icon: FileSpreadsheet, testid: "nav-import" },
    { to: "/acik-faturalar", label: "Açık Faturalar", icon: FileWarning, testid: "nav-open-invoices" },
];

export default function Layout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white text-brand-ink flex">
            {/* Sidebar */}
            <aside
                data-testid="app-sidebar"
                className="w-[260px] shrink-0 border-r border-black/10 bg-white flex flex-col"
            >
                <div className="p-6 border-b border-black/10">
                    <div className="flex items-center gap-2 mb-1">
                        <Lock size={14} className="text-brand-blue" strokeWidth={2.5} />
                        <span className="overline">Gizli · Erişim Kısıtlı</span>
                    </div>
                    <div className="font-display text-2xl font-black tracking-tight leading-none mt-2">
                        FERAHİS
                    </div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500 mt-1">
                        Tahsilat Kontrol Odası
                    </div>
                </div>

                <nav className="flex-1 py-4">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            data-testid={n.testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-6 py-3 border-l-2 transition-colors ${
                                    isActive
                                        ? "border-brand-blue bg-neutral-50 text-brand-ink"
                                        : "border-transparent text-neutral-600 hover:text-brand-ink hover:bg-neutral-50"
                                }`
                            }
                        >
                            <n.icon size={16} strokeWidth={2} />
                            <span className="text-sm">{n.label}</span>
                        </NavLink>
                    ))}
                    {user?.role === "admin" && (
                        <NavLink
                            to="/kullanicilar"
                            data-testid="nav-users"
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-6 py-3 border-l-2 transition-colors ${
                                    isActive
                                        ? "border-brand-blue bg-neutral-50 text-brand-ink"
                                        : "border-transparent text-neutral-600 hover:text-brand-ink hover:bg-neutral-50"
                                }`
                            }
                        >
                            <UserCog size={16} strokeWidth={2} />
                            <span className="text-sm">Kullanıcılar</span>
                        </NavLink>
                    )}
                </nav>

                <div className="border-t border-black/10 p-4">
                    <div className="flex flex-col gap-1 mb-3">
                        <span className="overline">Oturum</span>
                        <span data-testid="current-user-name" className="text-sm font-medium truncate">
                            {user?.name || user?.email}
                        </span>
                        <span className="text-[11px] font-mono uppercase text-neutral-500">
                            {user?.role === "admin" ? "Yönetici" : "Tahsilatçı"}
                        </span>
                    </div>
                    <button
                        data-testid="logout-button"
                        onClick={logout}
                        className="btn-outline w-full justify-center"
                    >
                        <LogOut size={13} /> Çıkış
                    </button>
                </div>
            </aside>

            {/* Main content */}
            <main className="flex-1 min-w-0 overflow-x-hidden">
                <Outlet />
            </main>
        </div>
    );
}
